module.exports = __webpack_public_path__ + "img/label.2df8a6c0.png";